import React, {useEffect, useRef, useState} from 'react';
import PropTypes from "prop-types";

import {LocalStorageContext} from "@/contexts/LocalStorageContext.jsx";
import {useModal} from "@/hooks/useModal.jsx";
import RestoreFromLocalStorageDialog from "@/components/dialogs/RestoreFromLocalStorageDialog.jsx";

export const LocalStorageProvider = ({storageKey, isRestoringAvailable = true, defaultValue = {}, children}) => {
    const {openModal, closeModal} = useModal();

    const [storageIsAvailable, setStorageIsAvailable] = useState(false);
    const [storageIsHavData, setStorageIsHaveData] = useState(false);

    const storage = useRef(null);
    // const [storage, setStorage] = useState({});

    useEffect(() => {
        if (storageKey?.length > 0) {
            const test = 'test';
            try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                setStorageIsAvailable(true);
            } catch (e) {
                setStorageIsAvailable(false);
            }
        }
    }, []);

    useEffect(() => {
        if (isRestoringAvailable && storageIsAvailable) {
            const storedDataJson = localStorage.getItem(storageKey);
            const storedData = JSON.parse(storedDataJson);

            if (storedData) {
                setStorageIsHaveData(true);
            }
        }
    }, [storageIsAvailable]);

    useEffect(() => {
        if (storageIsHavData) {
            openModal(
                <RestoreFromLocalStorageDialog
                    restoreFromStorage={() => {
                        restoreData();
                        closeModal();
                    }}
                    resetStorage={() => {
                        resetStoredData();
                        closeModal();
                    }}
                />
            );
        }
    }, [storageIsHavData]);

    const storeData = async (name, value) => {
        if (!storageIsAvailable || typeof name !== 'string') {
            return;
        }

        if (name === 'card_number' || name === 'card_cvc' || name === 'card_expiration') {
            return;
        }

        const data = {[name]: value};

        const newStorage = {...storage.current, ...{[name]: value}};

        if (JSON.stringify(storage) !== JSON.stringify(newStorage)) {
            storage.current = newStorage;

            try {
                localStorage.setItem(storageKey, JSON.stringify(Object.keys(newStorage).length !== 0 ? newStorage : null));
            } catch (e) {
            }
        }
    }


    const restoreData = () => {
        if (!storageIsAvailable) {
            return;
        }

        const storedDataJson = localStorage.getItem(storageKey);
        try {
            const storedData = JSON.parse(storedDataJson);

            const dataToRestore = {...defaultValue, ...storedData};
            storage.current = dataToRestore;
        } catch (e) {
        }
    }

    const getStoredData = () => {
        if (!storageIsAvailable) {
            return {};
        }

        return storage.current;
    }

    const resetStoredData = () => {
        if (!storageIsAvailable) {
            return;
        }

        try {
            localStorage.setItem(storageKey, JSON.stringify(null));
            storage.current = null;
        } catch (e) {
        }
    }

    return (
        <LocalStorageContext.Provider
            value={{storeData, resetStoredData, getStoredData}}>
            {children}
        </LocalStorageContext.Provider>
    );
};

LocalStorageProvider.propTypes = {
    children: PropTypes.any,
};
